<template>
  <div>
    <div class="cards-filters-tmk">
      <div class="cards-filters-tmk-side">
        <search-input
          v-if="isFilterVisible('search')"
          placeholder="Поиск по № карты, ФИО, Должности, Подразделению"
          style="width: 480px"
          v-model="filters.search"
          @change="filtersChanged"
        >
        </search-input>

        <cards-year-select
          v-if="isFilterVisible('years')"
          style="width:100px"
          v-model="filters.years"
          @change="filtersChanged"
        ></cards-year-select>

        <cards-period-select
          v-if="isFilterVisible('periods')"
          style="width:200px"
          v-model="filters.periods"
          @change="filtersChanged"
        ></cards-period-select>

        <cards-stage-select
          v-if="isFilterVisible('stages')"
          placeholder="Текущий этап"
          multiple
          v-model="filters.stages"
          @change="filtersChanged"
        ></cards-stage-select>
      </div>

      <div class="cards-filters-tmk-side">
        <el-select
          style="width: 300px"
          v-model="availableCards"
          multiple
          placeholder="Доступные карты"
        >
          <el-option label="Мои карты" value="my"></el-option>
          <el-option label="На моем шаге" value="my_turn"></el-option>
          <el-option label="Карты непосредственных подчиненных" value="subordinates"></el-option>
          <el-option label="Карты всех подчиненных" value="allSubordinates"></el-option>
          <el-option label="Карты 20+" value="top_level"></el-option>
        </el-select>

        <el-button
          style="font-weight: normal !important;"
          type="text"
          :icon="showSubdivisionFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
          @click="showSubdivisionFilters=!showSubdivisionFilters"
        >Подразделения</el-button>

        <el-button
          icon="fas fa-ban"
          @click="clearFilters"
        ></el-button>

      </div>
    </div>

    <div
      style="display: flex; justify-content: space-between; margin-top:10px"
      v-show="showSubdivisionFilters"
    >
      <LevelCardUserSubdivisionSelect
        style="width: 18%"
        v-model="filters.subdivision_1"
        placeholder="Верхнеуровневая дирекция"
        :subdivision-level="1"
        :filters="filters"
        multiple
        filterable
        @input="filtersChanged"
      ></LevelCardUserSubdivisionSelect>
      <LevelCardUserSubdivisionSelect
        style="width: 18%"
        v-model="filters.subdivision_2"
        placeholder="Подразделение 2"
        :subdivision-level="2"
        :filters="filters"
        multiple
        filterable
        @input="filtersChanged"
      ></LevelCardUserSubdivisionSelect>
      <LevelCardUserSubdivisionSelect
        style="width: 18%"
        v-model="filters.subdivision_3"
        placeholder="Подразделение 3"
        :subdivision-level="3"
        :filters="filters"
        multiple
        filterable
        @input="filtersChanged"
      ></LevelCardUserSubdivisionSelect>
      <LevelCardUserSubdivisionSelect
        style="width: 18%"
        v-model="filters.subdivision_4"
        placeholder="Подразделение 4"
        :subdivision-level="4"
        :filters="filters"
        multiple
        filterable
        @input="filtersChanged"
      ></LevelCardUserSubdivisionSelect>
      <LevelCardUserSubdivisionSelect
        style="width: 18%"
        v-model="filters.subdivision_5"
        placeholder="Подразделение 5"
        :subdivision-level="5"
        :filters="filters"
        multiple
        filterable
        @input="filtersChanged"
      ></LevelCardUserSubdivisionSelect>
    </div>

  </div>
</template>

<script>

import SearchInput from "@/components/filters/SearchInput";
import CardsYearSelect from "@/components/filters/cards/CardsYearSelect";
import CardsStageSelect from "@/components/filters/cards/CardsStageSelect";
import CardsStageNegotiationSelect from "@/components/filters/cards/CardsStageNegotiationSelect.vue";
import CardsPeriodSelect from "@/components/filters/cards/CardsPeriodSelect.vue";
import UserSelect from "@/components/filters/users/UserSelect.vue";
import CardsStatusSelect from "@/components/filters/cards/CardsStatusSelect.vue";
import LevelCardUserSubdivisionSelect from "@/componentsCompany/level/filters/LevelCardUserSubdivisionSelect.vue";

export default {
  name: "cards-page-filters",
  components: {
    LevelCardUserSubdivisionSelect,
    CardsStatusSelect,
    UserSelect,
    CardsPeriodSelect, CardsStageNegotiationSelect, CardsStageSelect, CardsYearSelect, SearchInput},

  props: {
    value: {},
    hidden: {type: Array},
  },

  computed: {},
  watch: {
    availableCards: function () {
      this.filters.my = this.availableCards.includes('my') ? 1 : null;
      this.filters.my_turn = this.availableCards.includes('my_turn') ? 1 : null;
      this.filters.card_type = this.availableCards.includes('top_level') ? 'top_level' : null;

      if( this.availableCards.includes('allSubordinates') ){
        this.filters.subordinates = this.$constants.user.subordinates.SUBORDINATES_ALL;
      } else if( this.availableCards.includes('subordinates') ){
        this.filters.subordinates = this.$constants.user.subordinates.SUBORDINATES_DIRECT;
      } else {
        this.filters.subordinates = this.$constants.user.subordinates.SUBORDINATES_NONE;
      }

      this.filtersChanged();
    },
  },
  data() {
    return {
      showSubdivisionFilters: false,
      availableCards: [],
      filters: {
        search: null,
        years: [],
        periods: [],
        stages: [],
        negotiation_user_ids: null,
        statuses: null,
        my: null,
        my_turn: null,
        my_role: null,
        type: null,
        subordinates: null,
        subdivision_1: [],
        subdivision_2: [],
        subdivision_3: [],
        subdivision_4: [],
        subdivision_5: [],
      },
    }
  },
  beforeMount() {
    // this.clearFilters();

    this.initFiltersFromQuery();

    if( this.filters.subdivision_1.length || this.filters.subdivision_2.length || this.filters.subdivision_3.length || this.filters.subdivision_4.length || this.filters.subdivision_5.length ){
      this.showSubdivisionFilters = true;
    }

    this.filters.my = this.$route.query.my ? 1 : null;
    if( this.filters.my ){
      this.availableCards.push('my');
    }
    this.filters.my_turn = this.$route.query.my_turn ? 1 : null;
    if( this.filters.my_turn ){
      this.availableCards.push('my_turn');
    }
  },
  mounted() {
    this.filters = {...this.filters, ...this.value};
    this.filtersChanged()
  },
  methods: {
    initFiltersFromQuery() {
      const query = this.$route.query;

      for (let key in this.filters) {
        if (query[key] !== undefined) {
          const current = this.filters[key];
          if (Array.isArray(current)) {
            this.filters[key] = Array.isArray(query[key])
              ? query[key]
              : [query[key]];
          } else {
            this.filters[key] = query[key];
          }
        }
      }
    },

    clearFilters(){
      this.filters.search = null;
      this.filters.years = [];
      this.filters.periods = [];
      this.filters.stages = [];
      this.filters.negotiation_user_ids = null;
      this.filters.statuses = null;
      this.filters.my = null;
      this.filters.my_turn = null;
      this.filters.my_role = null;
      this.filters.type = null;
      this.filters.subordinates = null;
      this.availableCards = [];
      this.filters.subdivision_1 = [];
      this.filters.subdivision_2 = [];
      this.filters.subdivision_3 = [];
      this.filters.subdivision_4 = [];
      this.filters.subdivision_5 = [];

      this.filtersChanged();
    },
    filtersChanged() {
      const cleanQuery = {};

      for (const key in this.filters) {
        const v = this.filters[key];
        if (v !== '' && v !== null && v !== undefined) {
          cleanQuery[key] = v;
        }
      }

      this.$router.replace({ query: cleanQuery }).catch(err => {});

      this.$emit('input', this.filters);
      this.$emit('change', this.filters);
    },

    isFilterVisible(filterName){
      if( this.hidden && this.hidden.includes(filterName) ){
        return false;
      }
      return true;
    },
  }
}
</script>


<style lang="scss">

.cards-filters-tmk {
  display: flex;
  justify-content: space-between;

  &-side {
    align-items: self-start;
    display: flex;
    gap: 1.5rem;
  }
}
</style>